
import {
    CLOSE_ACTION_TYPE,
    GET_OBJECT_INFO_ACTION_TYPE,
    SET_ACTUAL_OBJECT_SELECTED,
    SET_OBJECT_INFO,
    SHOW_ACTION_TYPE
} from '../sagas/info';

import {
    GET_PROJECT_ACTION_TYPE
} from '../sagas/project';

import {initialState as loaderInitialState, createLoaderReducer} from '../common/client/reducers/loader';

const initialState = {
    ...loaderInitialState,
    type: '',
    visible: false
};

export default function createReducer() {
    const loaderReducer = createLoaderReducer(GET_OBJECT_INFO_ACTION_TYPE);

    return (state = initialState, action) => {
        switch (action.type) {

            case CLOSE_ACTION_TYPE:
                return {
                    ...state,
                    visible: false
                };

            case SET_ACTUAL_OBJECT_SELECTED:
                return {
                    ...state,
                    data: {
                        result: {
                            ...state.data.result,
                            selected: action.selected
                        }
                    }
                };

            case SET_OBJECT_INFO:
                return {
                    ...state,
                    visible: true,
                    data: {
                        result: action.data
                    }
                }

            case SHOW_ACTION_TYPE:
                return {
                    ...state,
                    visible: true
                };

            case GET_PROJECT_ACTION_TYPE.DEFAULT:
                return {
                    ...initialState
                };

            default:
                return loaderReducer(state, action);
        }
    };
}
